import script from "./Borrow.vue?vue&type=script&setup=true&lang=ts"
export * from "./Borrow.vue?vue&type=script&setup=true&lang=ts"

import "./Borrow.vue?vue&type=style&index=0&id=72c7956f&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c7956f"]])

export default __exports__